import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgShotNotification = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 12,
	height: 12,
	viewBox: "0 0 12 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M10.5039 8.24854V10.4985H1.50391V8.24854H0.00390625V10.4985C0.00390625 11.3235 0.678906 11.9985 1.50391 11.9985H10.5039C11.3289 11.9985 12.0039 11.3235 12.0039 10.4985V8.24854H10.5039ZM2.25391 3.74854L3.31141 4.80604L5.25391 2.87104V8.99854H6.75391V2.87104L8.69641 4.80604L9.75391 3.74854L6.00391 -0.00146484L2.25391 3.74854Z",
		fill: "#7B7BFF"
	})
});
export { SvgShotNotification as ReactComponent };
